// extracted by mini-css-extract-plugin
export var grid_images_wrapper = "utilities-module--grid_images_wrapper--affee";
export var link_button_with_color = "utilities-module--link_button_with_color--eb1fa";
export var link_to_details_wrapper = "utilities-module--link_to_details_wrapper--ae22d";
export var palette_container = "utilities-module--palette_container--38b1b";